<template>
  <v-container id="setting-key-api-tables" fluid tag="section">
    <base-material-card icon="mdi-clipboard-text" class="px-5 py-3">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field v-model="editedItem.api" label="RAJA ONGKIR" disabled>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="editedItem.midtrans_server_backend_key"
                  label="MIDTRANS SERVER BACKEND API"
                  required
                  :rules="midtransBackend"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="editedItem.midtrans_server_snap_key"
                  label="MIDTRANS SERVER SNAP API"
                  required
                  :rules="midtransSnap"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions class="justify-center">
        <v-btn color="#1b5e20" class="white--text" elevation="2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </base-material-card>
    <div class="text-center">
      <v-dialog v-model="progressBar" width="100" hide-overlay>
        <v-progress-circular
          :size="60"
          color="primary"
          indeterminate
          align-center
          justify-center
        >
        </v-progress-circular>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    progressBar: false,
    editedItem: {
      api: "",
      midtrans_server_backend_key: "",
      midtrans_server_snap_key: "",
    },
    defaultItem: {
      api: "",
      midtrans_server_backend_key: "",
      midtrans_server_snap_key: "",
    },
    midtransBackend: [
      (v) => !!v || "MIDTRANS SERVER BACKEND API is required",
      (v) => (v && v.length <= 500) || "Max 500 characters",
    ],
    midtransSnap: [
      (v) => !!v || "MIDTRANS SERVER SNAP API is required",
      (v) => (v && v.length <= 500) || "Max 500 characters",
    ],
  }),
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  created() {
    this.go();
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
    }),
    save() {
      if (this.$refs.form.validate()) {
        this.progressBar = true;
        let formData = new FormData();
        formData.set("api", this.editedItem.api);
        formData.set("midtrans_server_backend_key", this.editedItem.midtrans_server_backend_key);
        formData.set("midtrans_server_snap_key", this.editedItem.midtrans_server_snap_key);
        formData.set("id", this.editedItem.id);
        let config = {
          headers: {
            Authorization: "Bearer " + this.user.api_token,
          },
        };
        this.axios
          .post("/api-key-midtrans/update", formData, config)
          .then((response) => {
            let { data } = response;
            this.setAuth(data.data);
            this.setAlert({
              status: true,
              text: data.message,
              color: "success",
            });
            this.clear();
          })
          .catch((error) => {
            let { data } = error;
            this.setAlert({
              status: true,
              text: data.message,
              color: "error",
            });
            this.clear();
          });
      }
    },
    go() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/api-key-midtrans";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.editedItem = data;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    clear() {
      this.progressBar = false;
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.position-relative {
  position: relative;
}
</style>
